import React from 'react';

const LassoSelectIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M11.25 6.042a5.5 5.5 0 1 1-1.13 8.356" />
    <path d="M12.5 18.356A5.5 5.5 0 1 0 20 12.5" />
    <path d="M12.5 12.5h-10l6-6 4 4Z" />
  </svg>
);

export default LassoSelectIcon;
